import React from "react"
import PropTypes from "prop-types"
import en from "react-phone-number-input/locale/en.json"

import { getCountryCallingCode } from "react-phone-number-input/input"
import { useWatch } from "react-hook-form"

import {
  StyledFlagImg,
  StyledDropdownWrapper,
} from "./CountryFlagDropdown.styles"

const CountryFlagDropdown = ({ control, extraStyles }) => {
  const country = useWatch({
    control,
    name: "country",
    defaultValue: "US",
  })

  return (
    <StyledDropdownWrapper extraStyles={extraStyles}>
      <StyledFlagImg
        alt={en[country]}
        role="presentation"
        loading="lazy"
        src={`https://catamphetamine.gitlab.io/country-flag-icons/3x2/${country}.svg`}
      />
      +{getCountryCallingCode(country)}
    </StyledDropdownWrapper>
  )
}

CountryFlagDropdown.propTypes = {
  control: PropTypes.any.isRequired,
  extraStyles: PropTypes.any,
}
CountryFlagDropdown.defaultProps = {
  extraStyles: "",
}
export default CountryFlagDropdown
